export const CATERING_PATH = '/order-catering';
export const FOUNDATION_PATH = '/public-safety-foundation';
export const CAREERS_PATH = 'https://careers.firehousesubs.ca';
export const DONATE_PATH =
  'https://www.canadahelps.org/en/charities/firehouse-subs-public-safety-foundation-of-canada/';
